import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import { initializeGTM } from './utilities/GTMModule';
import { history } from './history';
import { Provider } from 'react-redux';
import store from './store';

initializeGTM();

Sentry.init({
  dsn: window.configs != null && window.configs.sentrydns ? window.configs.sentrydns : '',
  environment: window.configs.environment,
});

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
